import { createContext, useContext } from 'react';

export interface profileData {
  firstName: string;
  customerType: string;
  dateOfBirth?: string;
}

interface Context {
  isMobileApp: boolean;
  activeSession?: boolean;
  isExistingCustomer?: boolean;
  profileData?: profileData;
}

const defaultValue = { isMobileApp: true };

export const AppContext = createContext<Context>(defaultValue);
export const useAppContext = () => useContext(AppContext);
